import React from 'react'
import I18n from 'translations/i18n'

import { ReactComponent as PunchIcon } from './icons/fingerprint.svg'
import { ReactComponent as EditIcon } from './icons/edit.svg'
import { ReactComponent as DeviceIcon } from './icons/mobile-devices.svg'

import Styles from './ProposedCorrectionTime.module.css'

export const reportMethodIcons = {
  biometric: <PunchIcon className={Styles.naturalDarker} />,
  geofencing: <DeviceIcon />,
  corrected: <EditIcon />,
  manual: <EditIcon />,
  bulk_upload: <EditIcon />,
}

export const correctTypes = [
  { value: 'existing', label: I18n.t('select_from_existing_punch') },
  { value: 'manually', label: I18n.t('enter_time_manually') },
]
